
const checkbox               = require ('../selector/checkbox')
const radio                  = require ('../selector/radio')
const textfieldHandler       = require ('../textfield/textfield-handler')
const textfieldMultiselect   = require ('../textfield/textfield-multiselect')


export function textfieldCheck(elem){ //console.log('textfieldCheck> HANDLER')

  var existError = false

    if( elem.html.querySelector('.elem').value === ''  &&  elem.required === true){ 

        existError = true
        textfieldHandler.error(elem.html)
    }

    if( elem.html.querySelector('.elem').value != ''  &&  elem.required === true){
        textfieldHandler.errorClean(elem.html)
    }

    return existError
}/**/



export function autocompleteCheck(elem, tabNotify){ //console.log('autocompleteCheck #####>')

    var existError = false
    
    const selected = elem.html.getAttribute('selected')

    if( selected === "[]"  &&  elem.required === true ){ 

        existError = true
        textfieldHandler.error(elem.html)

    }else{ textfieldHandler.errorClean(elem.html) }

    return existError
}/**/


export function textValidatorCheck(elem, tabNotify){

  var existError = false
    
  if( (elem.html.querySelector('input').value === ''  &&  elem.required === true) ||
       elem.html.classList.contains('textfield-error')  ){ 

       existError = true

       textfieldHandler.error(elem.html)
  }
 

    return existError
}/**/


export function checkboxCheck(elem, tabNotify){ //console.log('checkboxCheck>')

  var existError = false
    
  if( elem.html.querySelector('input').checked  === false  && elem.required === true){

      existError = true
     
      checkbox.error(elem.html)
      
  }

  if( elem.html.querySelector('input').checked  === true  && elem.required === true){
       checkbox.errorClean(elem.html)
  }

    return existError
}/**/



export function multiselectCheck(elem, tabNotify){ //console.log('multiselectCheck>')

  var existError = false
    
  if( elem.html.querySelector('select').value  === ''  && elem.required === true){ 

      existError = true
      
      textfieldMultiselect.error( elem.html)

  }else{ textfieldMultiselect.errorClean( elem.html);  }   
    return existError
}/**/



export function radioCheck(elem, tabNotify){ //console.log('radioCheck>')

  var existError = false

  if( radio.getValue(elem.html)  === ''  && elem.required === true){ 
    
    existError = true
    radio.error(elem.html)

  }else{ radio.errorClean(elem.html)  }    
    return existError
}/**/






















